import { Field, useFormikContext } from 'formik';
import React, { FC, useRef } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { getTimeZones } from '../../services/timeZoneService';
import { validateIpAddress, validateItemName } from '../../utilities/Validation';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';
import useFocusOnRouteChange from '../../hooks/useFocusOnRouteChange';

export const SiteCard: FC = () => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);
    
    return <>
        <div className="w-full p-2 inline-flex justify-start items-center bg-white">
            {values.id
                ? <div className="ml-8 mr-5 card-details">
                    <EntityHierarchy title={values.name} tree={{ label: values.name }} />
                </div>
                : null}
            <div className="flex flex-row">
                <div className="flex flex-col py-4 px-8">
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id='siteNameLabel'>
                            <Label
                                htmlFor="name"
                                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                            {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                        </div>
                        <Field id='siteNameInputId'
                            type="text"
                            name="name"
                            innerRef={inputRef}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                            validate={(value) => validateItemName(value, translate)} />
                    </div>
                    <div className="flex flex-row justify-between" id='hostNameLabel'>
                        <Label
                            htmlFor="hostIP"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.hostIP)}:</Label>
                        {errors.hostIP ? <span className='text-red-600 text-xs mt-1 ml-4'>{errors.hostIP}</span> : null}
                    </div>
                    <Field id='hostIpInputField'
                        type="text"
                        name="hostIP"
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={(value) => validateIpAddress(value, translate, true)}                    
                    />
                </div>
                <div className="flex flex-col py-4 px-8">
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id='wanIpLabel'>
                            <Label
                                htmlFor="wanIP"
                                className="text-xs text-gray-600 mt-1" >{translate.byKey(TranslationKeys.wanIP)}:</Label>
                            {errors.wanIP ? <span className='text-red-600 mt-1 ml-4 text-xs'>{errors.wanIP}</span> : null}
                        </div>
                        <Field id='wanIpInputField'
                            type="text"
                            name="wanIP"
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                            validate={(value) => validateIpAddress(value, translate)}                        
                        />
                    </div>
                    <div className="flex flex-row justify-between" id='timeZoneLabelId'>
                        <Label
                            htmlFor="timeZone"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.timeZone)}:</Label>
                        {errors.timeZoneId ? <span className='text-red-600 text-xs'>{errors.timeZoneId}</span> : null}
                    </div>
                    <div id='timeZoneDropDownId'>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.timeZone)}
                            key="timeZoneSelectField"
                            accessor='timeZoneId'
                            dataMethod={getTimeZones}
                            searchAccessor={'zone'}
                            required={true}
                            onSelect={(event, item) => {
                                setFieldValue('timeZone', item?.label);
                                setFieldValue('timeZoneId', item?.value);
                            }}
                            selectedItemLabel={values.timeZone} />
                    </div>
                </div>
            </div>
        </div>
    </>;
};
